import React from "react";
import {
  Box,
  Button,
  Container,
  Typography,
} from "@material-ui/core";

import {
  ArrowForwardIos,
  LocalFloristOutlined,
  RestaurantOutlined,
  LocalDiningOutlined,
  OpacityOutlined,
  EcoOutlined,
  WbSunnyOutlined,
  SpaOutlined,
  KitchenOutlined,
  LocalDrinkOutlined,
} from "@material-ui/icons";

interface CategoryItem {
  name: string;
  icon: React.ReactNode;
}

const categories: CategoryItem[] = [
  {
    name: "Vegetables",
    icon: <LocalFloristOutlined />,
  },
  {
    name: "Fruits",
    icon: <RestaurantOutlined />,
  },
  {
    name: "Meat",
    icon: <LocalDiningOutlined />,
  },
  {
    name: "Canned Organic",
    icon: <OpacityOutlined />,
  },
  {
    name: "Organic",
    icon: <EcoOutlined />,
  },
  {
    name: "Mushrooms",
    icon: <SpaOutlined />,
  },
  {
    name: "Organic Food",
    icon: <WbSunnyOutlined />,
  },
  {
    name: "Fresh Onion",
    icon: <EcoOutlined />,
  },
  {
    name: "Oatmeal",
    icon: <KitchenOutlined />,
  },
  {
    name: "Organic Juice",
    icon: <LocalDrinkOutlined />,
  },
];

const Hero: React.FC = () => {
  return (
    <section className="hero-section">
      <Container maxWidth="lg">
        <div className="hero-layout">

          {/* ==================================
              CATEGORY SIDEBAR
          ================================== */}

          <div className="hero-category-sidebar">
            {categories.map((category) => (
              <div
                className="hero-category-item"
                key={category.name}
              >
                <div className="hero-category-left">
                  <span className="hero-category-icon">
                    {category.icon}
                  </span>

                  <Typography>
                    {category.name}
                  </Typography>
                </div>

                <ArrowForwardIos className="category-arrow" />
              </div>
            ))}

            <div className="view-all-category">
              <span>View All</span>

              <ArrowForwardIos />
            </div>
          </div>

          {/* ==================================
              MEGA SALE
          ================================== */}

          <div className="mega-sale-banner">

            <div className="mega-sale-image" />

            <div className="mega-sale-content">

              <div className="eco-badge">
                <span>100%</span>
                <strong>ECO</strong>
              </div>

              <div className="discount-circle">
                %50
              </div>

              <Typography className="sale-small-text">
                Save Up to Flate
              </Typography>

              <Typography className="mega-sale-title">
                Mega Sale
              </Typography>

              <Button className="hero-shop-button">
                SHOP NOW
              </Button>
            </div>
          </div>

          {/* ==================================
              FRESH FRUIT
          ================================== */}

          <div className="fresh-fruit-banner">

            <div className="fresh-fruit-image" />

            <div className="fresh-fruit-content">

              <span className="sale-label">
                SALE
              </span>

              <Typography className="fresh-small-text">
                Save Up to Flate
              </Typography>

              <Typography className="fresh-fruit-title">
                Fresh Fruit
              </Typography>

              <Button className="hero-shop-button">
                SHOP NOW
              </Button>
            </div>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default Hero;